import * as types from '../../actions/shopList/shopActionTypes';
import { Shop } from '../../../pages/ShopList/types';

export interface ShopState {
  shop: Shop | null;
  loading: boolean;
  loaded: boolean;
}

const initialState: ShopState = {
  shop: null,
  loading: false,
  loaded: false,
};

export const shopReducer = (state = initialState, action: any): ShopState => {
  switch (action.type) {
    case types.GET_VISITOR_CLUB_DETAIL_REQUEST:
      return {
        ...state,
        loading: true,
        loaded: false,
      };

    case types.GET_VISITOR_CLUB_DETAIL_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        shop: action.data,
      };

    case types.GET_VISITOR_CLUB_DETAIL_FAILURE:
      return {
        ...state,
        loading: false,
        loaded: true,
        shop: null,
      };

    case types.GET_VISITOR_CLUB_DETAIL_INITIAL:
      return {
        ...state,
        loading: false,
        loaded: false,
        shop: null,
      };

    default:
      return state;
  }
};

export default shopReducer;
